// src/i18n/locales/en.js

export default {
  countries: {
    'AF': 'Afghanistan',
    'AL': 'Albania',
    'DZ': 'Algeria',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AG': 'Antigua and Barbuda',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AU': 'Australia',
    'AT': 'Austria',
    'AZ': 'Azerbaijan',
    'BS': 'Bahamas',
    'BH': 'Bahrain',
    'BD': 'Bangladesh',
    'BB': 'Barbados',
    'BY': 'Belarus',
    'BE': 'Belgium',
    'BZ': 'Belize',
    'BJ': 'Benin',
    'BT': 'Bhutan',
    'BO': 'Bolivia',
    'BA': 'Bosnia and Herzegovina',
    'BW': 'Botswana',
    'BR': 'Brazil',
    'BN': 'Brunei',
    'BG': 'Bulgaria',
    'BF': 'Burkina Faso',
    'BI': 'Burundi',
    'CV': 'Cabo Verde',
    'KH': 'Cambodia',
    'CM': 'Cameroon',
    'CA': 'Canada',
    'CF': 'Central African Republic',
    'TD': 'Chad',
    'CL': 'Chile',
    'CN': 'China',
    'CO': 'Colombia',
    'KM': 'Comoros',
    'CG': 'Congo',
    'CD': 'Congo, Democratic Republic of the',
    'CR': 'Costa Rica',
    'CI': 'Côte d\'Ivoire',
    'HR': 'Croatia',
    'CU': 'Cuba',
    'CY': 'Cyprus',
    'CZ': 'Czechia',
    'DK': 'Denmark',
    'DJ': 'Djibouti',
    'DM': 'Dominica',
    'DO': 'Dominican Republic',
    'EC': 'Ecuador',
    'EG': 'Egypt',
    'SV': 'El Salvador',
    'GQ': 'Equatorial Guinea',
    'ER': 'Eritrea',
    'EE': 'Estonia',
    'ET': 'Ethiopia',
    'FJ': 'Fiji',
    'FI': 'Finland',
    'FR': 'France',
    'GA': 'Gabon',
    'GM': 'Gambia',
    'GE': 'Georgia',
    'DE': 'Germany',
    'GH': 'Ghana',
    'GR': 'Greece',
    'GD': 'Grenada',
    'GT': 'Guatemala',
    'GN': 'Guinea',
    'GW': 'Guinea-Bissau',
    'GY': 'Guyana',
    'HT': 'Haiti',
    'HN': 'Honduras',
    'HU': 'Hungary',
    'IS': 'Iceland',
    'IN': 'India',
    'ID': 'Indonesia',
    'IR': 'Iran',
    'IQ': 'Iraq',
    'IE': 'Ireland',
    'IL': 'Israel',
    'IT': 'Italy',
    'JM': 'Jamaica',
    'JP': 'Japan',
    'JO': 'Jordan',
    'KZ': 'Kazakhstan',
    'KE': 'Kenya',
    'KI': 'Kiribati',
    'KP': 'Korea, North',
    'KR': 'Korea, South',
    'KW': 'Kuwait',
    'KG': 'Kyrgyzstan',
    'LA': 'Laos',
    'LV': 'Latvia',
    'LB': 'Lebanon',
    'LS': 'Lesotho',
    'LR': 'Liberia',
    'LY': 'Libya',
    'LI': 'Liechtenstein',
    'LT': 'Lithuania',
    'LU': 'Luxembourg',
    'MG': 'Madagascar',
    'MW': 'Malawi',
    'MY': 'Malaysia',
    'MV': 'Maldives',
    'ML': 'Mali',
    'MT': 'Malta',
    'MH': 'Marshall Islands',
    'MR': 'Mauritania',
    'MU': 'Mauritius',
    'MX': 'Mexico',
    'FM': 'Micronesia',
    'MD': 'Moldova',
    'MC': 'Monaco',
    'MN': 'Mongolia',
    'ME': 'Montenegro',
    'MA': 'Morocco',
    'MZ': 'Mozambique',
    'MM': 'Myanmar',
    'NA': 'Namibia',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NL': 'Netherlands',
    'NZ': 'New Zealand',
    'NI': 'Nicaragua',
    'NE': 'Niger',
    'NG': 'Nigeria',
    'MK': 'North Macedonia',
    'NO': 'Norway',
    'OM': 'Oman',
    'PK': 'Pakistan',
    'PW': 'Palau',
    'PS': 'Palestine, State of',
    'PA': 'Panama',
    'PG': 'Papua New Guinea',
    'PY': 'Paraguay',
    'PE': 'Peru',
    'PH': 'Philippines',
    'PL': 'Poland',
    'PT': 'Portugal',
    'QA': 'Qatar',
    'RO': 'Romania',
    'RU': 'Russia',
    'RW': 'Rwanda',
    'KN': 'Saint Kitts and Nevis',
    'LC': 'Saint Lucia',
    'VC': 'Saint Vincent and the Grenadines',
    'WS': 'Samoa',
    'SM': 'San Marino',
    'ST': 'Sao Tome and Principe',
    'SA': 'Saudi Arabia',
    'SN': 'Senegal',
    'RS': 'Serbia',
    'SC': 'Seychelles',
    'SL': 'Sierra Leone',
    'SG': 'Singapore',
    'SK': 'Slovakia',
    'SI': 'Slovenia',
    'SB': 'Solomon Islands',
    'SO': 'Somalia',
    'ZA': 'South Africa',
    'SS': 'South Sudan',
    'ES': 'Spain',
    'LK': 'Sri Lanka',
    'SD': 'Sudan',
    'SR': 'Suriname',
    'SZ': 'Eswatini',
    'SE': 'Sweden',
    'CH': 'Switzerland',
    'SY': 'Syria',
    'TJ': 'Tajikistan',
    'TZ': 'Tanzania',
    'TH': 'Thailand',
    'TL': 'Timor-Leste',
    'TG': 'Togo',
    'TO': 'Tonga',
    'TT': 'Trinidad and Tobago',
    'TN': 'Tunisia',
    'TR': 'Turkey',
    'TM': 'Turkmenistan',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ukraine',
    'AE': 'United Arab Emirates',
    'GB': 'United Kingdom',
    'US': 'United States',
    'UY': 'Uruguay',
    'UZ': 'Uzbekistan',
    'VU': 'Vanuatu',
    'VA': 'Vatican City',
    'VE': 'Venezuela',
    'VN': 'Vietnam',
    'YE': 'Yemen',
    'ZM': 'Zambia',
    'ZW': 'Zimbabwe'
  },
  verification: {
    verifying: 'Verifying your email...',
    success: 'Email Verified Successfully!',
    failed: 'Verification Failed',
    accountVerified: 'Your account has been successfully verified. You can now log in to your account.',
    invalidLink: 'The verification link is invalid or has expired.',
    missingToken: 'Verification token is missing.',
    generalError: 'An error occurred during verification. Please try again later.',
    proceedToLogin: 'Proceed to Login',
    backToLogin: 'Back to Login'
  },
  admin: {
    huduma: 'Genie AI',
    dashboard: 'Dashboard',
    system: 'System',
    settings: 'Settings',
    overview: 'Overview',
    database: 'Database',
    logs: 'Logs',
    userManagement: 'User Management',
    security: 'Security',
    systemAdministration: 'System Administration',
    loading: 'Loading...',
    close: 'Close dashboard',
    edit: 'Edit',
    systemUptime: 'System Uptime',
    avgResponseTime: 'Average Response Time',
    errorRate: 'Error Rate',
    activeUsers: 'Active Users',
    monthlyActiveUsers: 'Monthly Active Users (MAU)',
    fromLastMonth: 'from last month',
    today: 'Today',
    // --- UPDATED TABS ---
    tabs: {
      overview: 'System Health',
      hierarchy: 'Knowledge Hierarchy',
      documents: 'Document Management',
      database: 'Database',
      logs: 'Logs',
      security: 'Security',
      users: 'Users'
    },
    // --- NEW KEYS ---
    contentManagement: "CONTENT MANAGEMENT",
    knowledgeHierarchy: "Knowledge Hierarchy",
    documentManagement: "Document Management",
    noLogsFound: "No logs found for today",
    invalidLogsResponse: "Invalid logs summary response structure",
    logsSummaryError: "Failed to load logs summary",
    buttons: {
      save: "Save",
      cancel: "Cancel",
      switch: "Switch Anyway",
      discard: "Discard"
    },
    confirm: {
      defaultTitle: "Confirm",
      defaultMessage: "Are you sure?"
    },
    // --- END NEW KEYS ---
    systemHealthStatus: 'System Health Status',
    runDiagnostics: 'Run Diagnostics',
    resourceUsage: 'Resource Usage',
    services: {
      apiServices: 'API Services',
      database: 'Database',
      cache: 'Cache',
      storage: 'Storage',
      messageQueue: 'Message Queue',
      externalApi: 'External API'
    },
    resources: {
      cpu: 'CPU Usage',
      memory: 'Memory Usage',
      storage: 'Storage Usage',
      network: 'Network Bandwidth'
    },
    databaseManagement: 'Database Management',
    reindexDatabase: 'Reindex Database',
    lastReindex: 'Last Reindex',
    databaseSize: 'Database Size',
    totalTables: 'Total Tables',
    logManagement: 'Log Management',
    rolloverLogs: 'Rollover Logs',
    searchLogs: 'Search Logs',
    logTime: 'Time',
    logLevel: 'Level',
    logService: 'Service',
    logMessage: 'Message',
    showingEntries: 'Showing {start}-{end} of {total} entries',
    logLevels: {
      error: 'ERROR',
      warn: 'WARN',
      info: 'INFO',
      debug: 'DEBUG'
    },
    logMessages: {
      connectionTimeout: 'Connection timeout to external provider',
      lowDiskSpace: 'Disk space below 10% threshold',
      userRoleUpdated: 'User role updated for admin@huduma.ai'
    },
    userName: 'Name',
    userEmail: 'Email',
    userRole: 'Role',
    userStatus: 'Status',
    userActions: 'Actions',
    roleAdministrator: 'Administrator',
    roleUser: 'User',
    statusActive: 'Active',
    dbActions: {
      reindex: 'Reindex',
      backup: 'Backup',
      optimize: 'Optimize',
      reindexDesc: 'Rebuild database indexes',
      backupDesc: 'Create database backup',
      optimizeDesc: 'Optimize query performance'
    },
    operations: {
      reindexTitle: 'Database Reindex Results',
      backupTitle: 'Database Backup Results',
      optimizeTitle: 'Database Optimization Results',
      reindexResults: 'Reindex Results',
      optimizeResults: 'Optimization Results',
      collection: 'Collection',
      status: 'Status',
      indexSuggestions: 'Index Suggestions',
      backupDetails: 'Backup Details',
      backupFile: 'Backup File',
      backupLocation: 'Location',
      backupSize: 'Size',
      errorDetails: 'Error Details',
      close: 'Close',
      resultsTitle: 'Operation Results',
      reindexDatabase: {
        success: 'Database reindexing completed successfully',
        error: 'Error during database reindexing',
        loading: 'Reindexing database...'
      },
      backupDatabase: {
        success: 'Database backup completed successfully',
        error: 'Error during database backup',
        loading: 'Backing up database...'
      },
      optimizeDatabase: {
        success: 'Database optimization completed successfully',
        error: 'Error during database optimization',
        loading: 'Optimizing database...'
      },
      rolloverLogs: {
        success: 'Log rollover completed successfully',
        loading: 'Rolling over logs...'
      },
      searchLogs: {
        success: 'Log search completed',
        loading: 'Searching logs...'
      },
      runDiagnostics: {
        success: 'Diagnostics completed successfully',
        loading: 'Running diagnostics...'
      },
      runSecurityScan: {
        success: 'Security scan completed successfully',
        loading: 'Running security scan...'
      },
      cancel: 'Cancel',
      save: 'Save Changes'
    },
    userManagementSection: {
      totalUsers: 'Total Users',
      newUsers: 'New Users (Month)',
      searchUsers: 'Search users...',
      clearSearch: 'Clear search',
      search: 'Search',
      usersFound: 'users found',
      showAllUsers: 'Show All Users',
      searching: 'Searching...',
      searchingUsers: 'Searching for users...',
      noUsersFound: 'No users found matching your search criteria.',
      noUsers: 'No users available.',
      showing: 'Showing',
      of: 'of',
      previous: 'Previous',
      next: 'Next',
      searchFields: {
        all: 'All Fields',
        name: 'Name',
        email: 'Email',
        role: 'Role'
      },
      userSearch: {
        resultsFound: 'Found {total} users matching "{term}"',
        error: 'Error searching users'
      }
    },
    logsSection: {
      errorLogs: 'Error Logs',
      warningLogs: 'Warning Logs',
      noErrorLogs: 'No error logs recorded today.',
      noWarningLogs: 'No warning logs recorded today.',
      infoLogsNote: 'Info logs are not shown in the summary. Use the search function to view all log types.',
      searchResults: 'Latest Search Results',
      entriesFound: 'entries found',
      viewAllResults: 'View All Results',
      logType: 'Type',
      logCount: 'Count',
      logTypes: {
        connectionTimeout: 'Connection timeout',
        databaseFailed: 'Database query failed',
        authFailed: 'Authentication failure',
        lowDiskSpace: 'Disk space below threshold',
        slowQuery: 'Slow query performance',
        rateLimit: 'Rate limit approaching'
      },
      logSearch: {
        noResultsFound: 'No logs matched your search criteria',
        resultsFound: 'Found {count} log entries'
      }
    },
    security: {
      title: 'Security Monitoring',
      securityScan: 'Security Scan',
      runningSecurityScan: 'Running Scan...',
      lastSecurityScan: 'Last Security Scan',
      vulnerabilitiesFound: 'Vulnerabilities Found',
      daysAgo: 'days ago',
      critical: 'critical',
      medium: 'medium',
      low: 'low',
      failedLoginAttempts: 'Failed Login Attempts (24h)',
      suspiciousActivities: 'Suspicious Activities (24h)',
      securityRecommendations: 'Security Recommendations',
      criticalVulnerabilities: 'Critical Vulnerabilities',
      mediumVulnerabilities: 'Medium Vulnerabilities',
      lowVulnerabilities: 'Low Vulnerabilities',
      authenticationIssues: 'Authentication Issues',
      suspiciousActivityLogs: 'Suspicious Activity Logs',
      securityProbeAttempts: 'Security Probe Attempts Detected',
      sensitiveFileAccess: 'attempts to access sensitive files or endpoints detected',
      envFileAccess: 'Environment File Access Attempts',
      envFileAccessDesc: 'attempts to access .env files detected',
      gitRepoAccess: 'Git Repository Access Attempts',
      gitRepoAccessDesc: 'attempts to access Git repository files detected',
      recommendedAction: 'Recommended Action',
      rateLimitRecommendation: 'Consider implementing rate limiting, IP blocking for persistent offenders, and ensure proper server hardening is in place.',
      envFileRecommendation: 'Ensure environment files are not accessible from web directories and server configurations properly block access to sensitive files.',
      gitRepoRecommendation: 'Make sure .git directories are properly secured and not accessible from the web.',
      noVulnerabilitiesFound: 'No Vulnerabilities Found',
      systemSecure: 'Your system appears to be secure. Continue monitoring regularly.',
      loadingScan: 'Loading scan results...',
      occurrences: 'Occurrences',
      firstSeen: 'First Seen',
      lastSeen: 'Last Seen',
      timestamp: 'Timestamp',
      message: 'Message',
      service: 'Service',
      type: 'Type',
      severity: 'Severity',
      url: 'URL',
      matchedTerm: 'Matched Term',
      lineNumber: 'Line Number',
      lineNumbers: 'Line Numbers',
      showLess: 'Show Less',
      showMore: 'Show All Issues',
      // --- NEW KEY ---
      lastScanJustNow: "Just now"
    },
    userEdit: {
      title: 'Edit User',
      loading: 'Loading user data...',
      userInfo: 'User Information',
      userId: 'User ID',
      loginName: 'Login Name',
      fullName: 'Full Name',
      dob: 'Date of Birth',
      email: 'Email',
      emailVerified: 'Email Verified',
      verified: 'Verified',
      notVerified: 'Not Verified',
      createdAt: 'Created',
      lastLogin: 'Last Login',
      never: 'Never',
      accountSettings: 'Account Settings',
      accountStatus: 'Account Status',
      accountEnabled: 'Account Enabled',
      cannotDisableSelf: 'You cannot disable your own account',
      accountRole: 'Account Role',
      adminRole: 'Admin Role',
      cannotChangeOwnRole: 'You cannot change your own role',
      adminActions: 'Admin Actions',
      verifyEmail: 'Verify Email',
      resetPassword: 'Send Password Reset',
      forceLogout: 'Force Logout',
      failedToLoad: 'Failed to load user data',
      errorLoading: 'Error loading user data',
      saveSuccess: 'User settings updated successfully',
      errorSaving: 'Error saving user settings',
      verifyEmailSuccess: 'Verification email sent successfully',
      emailVerificationFailed: 'Failed to send verification email',
      errorVerifyingEmail: 'Error sending verification email',
      passwordResetSent: 'Password reset email sent',
      passwordResetFailed: 'Failed to send password reset',
      errorSendingReset: 'Error sending password reset',
      logoutForced: 'User has been logged out',
      logoutFailed: 'Failed to force logout',
      errorForcingLogout: 'Error forcing logout',
      // --- NEW KEY ---
      userUpdated: "User updated successfully"
    },
    // --- NEW OBJECT ---
    hierarchy: {
      title: "Knowledge Hierarchy Management (note: always English - add translations)",
      addCategory: "Add New Category",
      loading: "Loading Hierarchy...",
      addService: "Add Service",
      editCategory: "Edit Category",
      deleteCategory: "Delete Category",
      editService: "Edit Service",
      deleteService: "Delete Service",
      empty: 'No categories found. Click "Add New Category" to start.',
      formTitleCreateCategory: "Create New Category",
      formTitleAddService: "Add Service to \"{categoryName}\"",
      formTitleEditCategory: "Edit Category: \"{itemName}\"",
      formTitleEditService: "Edit Service: \"{itemName}\"",
      nameEnLabel: "Name (English)",
      translationsTitle: "Translations for Display",
      loadingTranslations: "Loading translations...",
      selectLang: "Select Language",
      translationPlaceholder: "Enter translation",
      deleteTranslation: "Delete Translation",
      addTranslation: "+ Add Translation",
      saveSuccess: "Hierarchy item saved successfully.",
      saveError: "Failed to save hierarchy item.",
      loadError: "Failed to load knowledge hierarchy.",
      loadTranslationsError: "Failed to load translations.",
      confirmCancelTitle: "Unsaved Changes",
      confirmCancelEdit: "You have unsaved changes. Are you sure you want to cancel?",
      confirmDeleteTitleCategory: "Delete Category?",
      confirmDeleteTitleService: "Delete Service?",
      confirmDeleteCategory: "Are you sure you want to delete the Category \"{itemName}\"? This action cannot be undone.",
      confirmDeleteService: "Are you sure you want to delete the Service \"{itemName}\"? This action cannot be undone.",
      deleteSuccessCategory: "Category deleted successfully.",
      deleteSuccessService: "Service deleted successfully.",
      deleteErrorCategory: "Failed to delete Category.",
      deleteErrorService: "Failed to delete Service.",
      duplicateLangError: "Duplicate languages found in translations. Please remove them."
    },
    // --- NEW OBJECT ---
    documents: {
      title: "Document Management",
      addLink: "Add from Link",
      uploadFiles: "Upload Files",
      searchPlaceholder: "Search by file name...",
      allStatuses: "All Statuses",
      statusPending: "Pending",
      statusIngested: "Ingested",
      statusRetracted: "Retracted",
      // --- NEW STATUSES ---
      statusIngesting: "Ingesting",
      statusError: "Ingestion Error",
      statusWarning: "Ingested with Warnings",
      // ---
      ingestSelected: "Ingest Selected",
      colFileName: "File Name",
      colStatus: "Status",
      colLabels: "Labels",
      colUploadDate: "Upload Date",
      colSize: "Size",
      loading: "Loading documents...",
      empty: "No documents found.",
      loadError: "Failed to load documents.",
      confirmIngestTitle: "Confirm Batch Ingestion",
      ingest: "Ingest",
      confirmIngestSelected: "Are you sure you want to ingest {count} selected file(s)?",
      ingestQueuedSuccess: "{count} file(s) have been queued for ingestion.",
      ingestQueuedError: "An error occurred during the batch ingestion process.",
      uploadSuccessMultiple: "{count} file(s) uploaded successfully.",
      linkSubmitSuccess: "Successfully crawled and saved \"{fileName}\".",
      actionSuccess: "Action \"{action}\" on file {fileId} was successful.",
      metadataUpdateSuccess: "Metadata for file {fileId} was updated."
    }
  },
  passwordResetConfirm: {
    appTitle: 'Genie AI',
    resetPassword: 'Create New Password',
    tokenLabel: 'Reset Token',
    tokenPlaceholder: 'Enter reset token',
    validateButton: 'Validate Token',
    newPasswordLabel: 'New Password',
    newPasswordPlaceholder: 'Create a new password',
    confirmNewPasswordLabel: 'Confirm New Password',
    confirmNewPasswordPlaceholder: 'Confirm your new password',
    resetButton: 'Reset Password',
    processing: 'Resetting...',
    rememberedPassword: 'Remember your password?',
    backToLogin: 'Back to Login',
    supportMessage: 'Need help? Contact our support team',
    passwordRequirements: 'Password must be at least 8 characters with at least 1 number, 1 uppercase letter, and 1 special character',
    passwordsDoNotMatch: 'Passwords do not match',
    resetSuccess: 'Your password has been successfully reset',
    resetFailed: 'Unable to reset password. Please try again.',
    noTokenProvided: 'Please provide a reset token',
    expiredToken: 'This reset token has expired. Please request a new one.',
    invalidToken: 'Invalid or unrecognized reset token',
    validatingToken: 'Validating token...',
    redirecting: 'Redirecting to login page...',
    passwordStrength: 'Password Strength',
    strengthLabels: {
      veryWeak: 'Very Weak',
      weak: 'Weak',
      fair: 'Fair',
      good: 'Good',
      strong: 'Strong'
    },
    passwordSuggestions: {
      atLeast8Chars: 'Use at least 8 characters',
      addUppercase: 'Add uppercase letters',
      addLowercase: 'Add lowercase letters',
      addNumbers: 'Add numbers',
      addSpecialChars: 'Add special characters'
    }
  },
  passwordReset: {
    appTitle: 'Genie AI',
    resetPassword: 'Reset Your Password',
    emailLabel: 'Email Address',
    emailPlaceholder: 'Enter your email',
    resetButton: 'Send Reset Link',
    processing: 'Sending...',
    rememberPassword: 'Remember your password?',
    backToLogin: 'Back to Login',
    supportMessage: 'Need help? Contact our support team',
    invalidEmail: 'Please enter a valid email address',
    resetRequestSuccess: 'Password reset link has been sent to your email',
    resetRequestFailed: 'Unable to send password reset link. Please try again.',
    checkEmail: 'Please check your email for further instructions.'
  },
  register: {
    appTitle: "Genie AI",
    createAccount: "Create New Account",
    username: "Username",
    usernamePlaceholder: "Enter a username",
    email: "Email",
    emailPlaceholder: "Enter your email",
    password: "Password",
    passwordPlaceholder: "Create a password",
    confirmPassword: "Confirm Password",
    confirmPasswordPlaceholder: "Confirm your password",
    acceptTerms: "I accept the",
    termsOfService: "Terms of Service",
    registerButton: "Create Account",
    processing: "Processing...",
    alreadyHaveAccount: "Already have an account?",
    loginNow: "Log in",
    privacyNotice: "By registering, you agree to our Terms of Service and Privacy Policy",
    usernameMinLength: "Username must be at least 3 characters",
    invalidEmail: "Please enter a valid email address",
    passwordRequirements: "Password must be at least 8 characters with at least 1 number and 1 uppercase letter",
    passwordsDoNotMatch: "Passwords do not match",
    mustAcceptTerms: "You must accept the Terms of Service",
    registrationFailed: "Registration failed. Please try again.",
    usernameExists: "Username already exists",
    emailExists: "Email already exists",
    registrationSuccess: "Registration Successful!",
    verificationEmailSent: "A verification email has been sent to {email}",
    checkEmailInstructions: "Please check your email and follow the instructions to verify your account before logging in.",
    backToLogin: "Back to Login",
    noEmailReceived: "Didn't receive an email?",
    resendVerification: "Resend verification email",
    verificationResent: "Verification email has been resent",
    verificationResendFailed: "Failed to resend verification email. Please try again.",
    usernameInvalidChars: 'Username can only contain letters, numbers, underscores, dots and hyphens',
    networkError: 'Network error. Please check your connection and try again.'
  },
  login: {
    appTitle: 'Genie AI',
    username: 'Username',
    password: 'Password',
    loginButton: 'Login',
    or: 'or',
    savedAccounts: 'Saved Accounts',
    loginSuccess: 'Login successful',
    loginError: 'Login failed. Please check your credentials.',
    googleLogin: 'Continue with Google',
    facebookLogin: 'Continue with Facebook',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    noAccount: 'Don\'t have an account?',
    createAccount: 'Create account',
    registerNow: "Register now",
    termsAndPolicy: 'By logging in, you agree to our Terms of Service and Privacy Policy',
    loggingIn: "Logging in...",
    fieldsRequired: "Username and password are required",
    invalidCredentials: "Invalid username or password",
    tooManyAttempts: "Too many login attempts. Please try again later.",
    loginFailed: "Login failed. Please try again.",
    oauthNotImplemented: "Social login is not yet implemented",
    savedLoginNotImplemented: "Saved account login is not yet implemented"
  },
  charts: {
    tooltip: {
      title: 'Date',
      totalQueries: 'Total Queries',
      uniqueUsers: 'Unique Users'
    },
    day: 'Day',
    noData: 'No Data',
    notAvailable: 'N/A',
    topQueries: 'Top Queries',
    categoryDistribution: 'Knowledge Area Usage',
    usageTrend: 'Usage Trend'
  },
  analytics: {
    title: 'Data Analytics & Insights',
    loading: 'Loading analytics data...',
    period: 'Time Period',
    charts: {
      satisfactionHeatmap: "Satisfaction by Knowledge Area",
      satisfactionSubtitle: "Percentage scores over time"
    },
    timePeriods: {
      week4: "4 Weeks Ago",
      week3: "3 Weeks Ago",
      week2: "2 Weeks Ago",
      week1: "Last Week",
      current: "Current"
    },
    errors: {
      loading: "Failed to load satisfaction data. Please try again.",
    },
    status: {
      loading: 'Loading...',
      noData: 'No data available for this period',
      error: 'Failed to load analytics data',
      online: "System Online",
      offline: "System Offline",
      responseTime: "Avg. Response Time",
      queueLength: "Queue",
      uptime: "Uptime"
    },
    periods: {
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      allTime: 'All Time'
    },
    metrics: {
      totalQueries: 'Total Queries',
      uniqueUsers: 'Unique Users',
      avgResponseTime: 'Avg Response Time',
      satisfaction: 'User Satisfaction'
    },
    table: {
      rank: 'Rank',
      query: 'Query',
      count: 'Count',
      avgTime: 'Avg. Time'
    },
    chartLabels: {
      categories: 'Areas',
      serviceCategories: 'Knowledge Areas',
      byUsage: 'by Usage',
      category: 'Area'
    },
    tooltips: {
      selectPeriod: 'Select time period',
      selectDate: 'Select date',
      exportData: 'Export data'
    },
    gauge: {
      historical: 'Historical Trends',
      vsPrevious: 'vs previous period',
      target: 'Target'
    },
    ratings: {
      poor: "Poor",
      average: "Average",
      good: "Good",
      excellent: "Excellent"
    },
    slower: 'slower',
    faster: 'faster',
    percentage: 'Percentage',
    note: 'Below are usage stats and user feedback summaries.',
    usageStats: 'Usage Statistics',
    peakUsers: 'Peak Concurrent Users',
    activeChats: 'Active Chats',
    usageTrend: 'Usage Trend',
    topQueries: 'Top Queries',
    feedbackSamples: 'User Feedback Samples',
    close: 'Close',
    chartComingSoon: 'Interactive chart visualization coming soon...',
    retry: 'Retry',
    dailyQueries: 'Daily Queries',
    export: 'Export Data',
    dateRange: 'Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    rank: 'Rank',
    query: 'Query',
    count: 'Count',
    avgTime: 'Avg. Time',
    serviceUsage: 'Knowledge Area Usage',
    usageTrends: 'Usage Trends',
    week: 'Last Week',
    month: 'Last Month',
    quarter: 'Last Quarter',
    year: 'Last Year',
    uniqueUsers: 'Unique Users',
    satisfactionRate: 'Satisfaction Rate',
    satisfactionAnalysis: 'User Satisfaction Analysis'
  },
  brandName: 'Genie AI: Your Digital Government Assistant',
  nav: {
    systemStatus: 'System Status',
    menu: 'Menu',
    analytics: 'Analytics',
    userProfile: 'User Profile',
    settings: 'Settings',
    logout: 'Log Out',
    profile: 'My Profile',
    toggleSidebar: 'Toggle sidebar',
    changeLanguage: 'Change language',
    administration: "Administration",
    languages: {
      english: 'English',
      french: 'French',
      swahili: 'Swahili'
    }
  },
  systemStatus: {
    title: 'Service Status',
    services: 'Services',
    operational: 'Operational',
    degraded: 'Degraded',
    outage: 'Outage',
    allOperational: 'All Systems',
    someIssues: 'Some Issues',
    majorIssues: 'Major Issues',
    checking: 'Checking...',
    nextDeadline: 'Next Deadline',
    days: 'days',
    viewDetails: 'View Details'
  },
  services: {
    eCitizen: 'eCitizen Portal',
    taxFiling: 'Tax Filing System',
    idApplication: 'ID Application',
    businessReg: 'Business Registration',
    drivingLicense: 'Driving License'
  },
  deadlines: {
    taxFiling: 'Tax Filing Deadline',
    businessRenewal: 'Business License Renewal',
    idRenewal: 'ID Card Renewal',
    vehicleRegistration: 'Vehicle Registration Deadline'
  },
  sidebar: {
    governmentServices: 'Knowledge Areas',
    chatHistory: 'Chat History',
    searchPlaceholder: 'Search knowledge areas...',
    createFolder: 'Create Folder',
    editFolder: 'Edit Folder',
    folderName: 'Folder Name',
    folderNamePlaceholder: 'Enter folder name',
    moveChat: 'Move Chat',
    moveChatTo: 'Move Chat To',
    selectFolder: 'Select Folder',
    deleteChat: 'Delete Chat',
    deleteChatConfirm: 'Are you sure you want to delete this chat?',
    deleteChatWarning: 'This action cannot be undone.',
    renameChat: "Rename Chat",
    chatTitle: "Chat Title",
    chatTitlePlaceholder: "Enter a title for this chat",
    deleteFolder: "Delete Folder",
    deleteFolderConfirm: "Are you sure you want to delete '{name}' folder?",
    chatsMoveWarning: "All chats in this folder will be moved to the default folder.",
    weatherError: "Unable to load weather data. Please try again.",
    weatherTitle: 'Weather Forecast',
    weatherLoading: 'Loading weather data...',
    weatherLocationLoading: 'Loading location...',
    weatherErrorDefault: 'Unable to retrieve weather data.',
    weatherGeolocationUnsupported: 'Geolocation not supported by your browser.',
    weatherRefresh: 'Refresh Weather',
    weatherConditions: {
      clear: 'Clear',
      partlycloudy: 'Partly Cloudy',
      cloudy: 'Cloudy',
      overcast: 'Overcast',
      rain: 'Rain',
      shower: 'Shower',
      thunderstorm: 'Thunderstorm',
      snow: 'Snow'
    },
    folders: "Folders",
    emptyFolder: "This folder is empty. Move conversations here from the chat menu.",
    title: 'Info & Resources',
    noChats: 'No recent chats',
    relatedDocs: 'Related Documents',
    noDocuments: 'No related documents',
    faq: 'Frequently Asked Questions',
    tab: {
      all: 'All Chats',
      folders: 'Folders',
      starred: 'Starred',
      archived: 'Archived'
    },
    savedChats: 'Saved Chats',
    chats: "Chats",
    allChats: "All Chats",
    noFolder: "No Folder",
    starredChats: "Starred Chats",
    archivedChats: "Archived Chats",
    noStarredChats: "No starred conversations yet. Star a conversation to add it here.",
    noArchivedChats: "No archived conversations yet.",
    noSearchResults: 'No conversations found for "{term}"',
    loadingChats: "Loading conversations...",
    errorLoadingConversations: "Failed to load conversations. Please try again.",
    errorLoadingUser: "User data is incomplete. Please reload the page.",
    errorNoUser: "User data is missing. Please reload the page.",
    retry: "Retry",
    message: "message",
    messages: "messages",
    created: "Created",
    updated: "Updated",
    star: "Star",
    unstar: "Unstar",
    archive: "Archive",
    chatStarred: "Conversation has been starred",
    chatUnstarred: "Conversation has been unstarred",
    chatArchived: "Conversation has been archived",
    chatUnarchived: "Conversation has been unarchived",
    errorUpdatingChat: "Failed to update conversation",
    chatRenamed: "Conversation renamed successfully",
    errorRenamingChat: "Failed to rename conversation",
    chatDeleted: "Conversation deleted successfully",
    errorDeletingChat: "Failed to delete conversation",
    chatMoved: "Conversation moved successfully",
    errorMovingChat: "Failed to move conversation",
    noPreview: "No preview available",
    searchConversations: 'Search conversations...',
    selectFolderInstruction: "Select a folder to view its conversations",
    folderCreated: "Folder created successfully",
    errorCreatingFolder: "Failed to create folder",
    errorLoadingFolders: "Failed to load folders",
    folderUpdated: "Folder updated successfully",
    errorUpdatingFolder: "Failed to update folder",
    folderDeleted: "Folder deleted successfully",
    errorDeletingFolder: "Failed to delete folder",
    chatRemovedFromFolders: "Conversation removed from folder",
    errorRemovingChat: "Failed to remove conversation from folder",
    id: 'ID',
    labels: 'Labels',
    confidence: 'Confidence',
    unknown: 'Unknown'
  },
  leftPanel: {
    cat1: {
      name: '1. Identity & Civil Registration',
      children: ['Birth certificates', 'National ID cards', 'Passports', 'Marriage and death certificates', 'Voter registration']
    },
    cat2: {
      name: '2. Healthcare & Social Services',
      children: ['Public healthcare access', 'Vaccination programs', 'Health insurance', 'Disability benefits', 'Welfare and food assistance']
    },
    cat3: {
      name: '3. Education & Learning',
      children: ['Public schools and universities', 'Scholarships and student loans', 'Adult education programs', 'Online learning resources']
    },
    cat4: {
      name: '4. Employment & Labor Services',
      children: ['Job search and unemployment benefits', 'Worker protections and labor rights', 'Workplace safety regulations', 'Skills training and apprenticeships']
    },
    cat5: {
      name: '5. Taxes & Revenue',
      children: ['Income tax filing and refunds', 'Property tax payments', 'Business tax compliance', 'Customs and import duties']
    },
    cat6: {
      name: '6. Public Safety & Justice',
      children: ['Police and emergency services', 'Court and legal aid services', 'Crime reporting', 'Consumer protection laws']
    },
    cat7: {
      name: '7. Transportation & Mobility',
      children: ["Driver's licenses and vehicle registration", 'Public transit and infrastructure', 'Traffic violations and fines', 'Road safety programs']
    },
    cat8: {
      name: '8. Housing & Urban Development',
      children: ['Public housing assistance', 'Property registration and land records', 'Housing loans and subsidies', 'Zoning and building permits']
    },
    cat9: {
      name: '9. Utilities & Environment',
      children: ['Water and electricity services', 'Waste management and recycling', 'Environmental regulations', 'Renewable energy initiatives']
    },
    cat10: {
      name: '10. Business & Trade',
      children: ['Business registration and licensing', 'Trade regulations and permits', 'Small business grants and incentives', 'E-commerce and digital business support']
    },
    cat11: {
      name: '11. Social Security & Pensions',
      children: ['Retirement benefits', 'Pension fund management', 'Survivor benefits', 'Disability pensions']
    },
    cat12: {
      name: '12. Community & Civic Engagement',
      children: ['Voting and elections', 'Public feedback and citizen complaints', 'Volunteering and community programs', 'Local government participation']
    }
  },
  settings: {
    title: 'Settings',
    save: 'Save',
    close: 'Close',
    saveSettings: 'Save Settings',
    savingSettings: "Saving your settings...",
    settingsSaved: "Settings saved successfully!",
    saveSuccess: 'Settings saved successfully',
    saveError: 'Error saving settings',
    display: 'Display',
    displayLanguage: 'Display Language',
    languages: {
      english: 'English',
      french: 'French',
      swahili: 'Swahili'
    },
    theme: 'Theme',
    themes: {
      light: 'Light',
      dark: 'Dark',
      system: 'System'
    },
    fontSize: 'Font Size',
    notifications: 'Notifications',
    emailUpdates: 'Email updates',
    soundNotifications: 'Sound notifications',
    accountManagement: 'Account Management',
    emailAddress: 'Email Address',
    emailAddressPlaceholder: 'Your email address',
    password: 'Password',
    changePassword: 'Change Password',
    resetUserData: 'Reset User Data',
    resetUserDataDesc: 'This will clear all your profile data and chat history.',
    deleteAccount: 'Delete Account',
    deleteAccountDesc: 'This will permanently delete your account and all associated data.',
    edit: 'Edit',
    standardAccount: 'Standard Account',
    confirmEmailChange: 'Confirm Email Change',
    pleaseEnterPassword: 'Please enter your password',
    cancel: 'Cancel',
    account: {
      title: 'Account',
      resetDescription: 'This will clear all your profile data and chat history.',
      confirmReset: 'Are you sure you want to reset all your data? This cannot be undone.',
      resetComplete: 'Your data has been reset.'
    },
    language: {
      title: 'Language',
      selectLabel: 'Display Language'
    },
    appearance: {
      title: 'Appearance',
      lightTheme: 'Light',
      darkTheme: 'Dark',
      systemTheme: 'System'
    },
    confirmDeleteAccount: 'Are you sure you want to delete your account? This action cannot be undone.',
    confirmAccountDeletion: 'Confirm Account Deletion',
    accountDeletionWarning: 'Warning: This action is permanent and cannot be undone. All your data will be permanently deleted.',
    deletionReason: 'Reason for deletion (optional):',
    deletionReasonPlaceholder: 'What made you decide to delete your account?',
    enterPasswordConfirm: 'Enter your password to confirm:',
    currentPasswordPlaceholder: 'Your current password',
    deleting: 'Deleting...',
    permanentlyDeleteAccount: 'Delete Account',
    accountDeletedSuccess: 'Your account has been deleted successfully.',
    incorrectPassword: 'Incorrect password',
    accountDeletionFailed: 'Failed to delete account. Please try again later.',
    confirmChange: 'Confirm Change',
    processing: 'Processing...',
    userDataReset: 'Your profile data has been successfully reset.',
    failedToResetUserData: 'Failed to reset your profile data. Please try again later.',
    changingEmailTo: 'Changing your email to',
    will: 'will',
    logOutSystem: 'Log you out of the system',
    sendVerificationLink: 'Send a verification link to your new email',
    requireVerification: 'Require verification before you can log in again',
    checkNewEmailVerification: 'Please check your new email for verification instructions.',
    unableToVerifyEmail: 'Unable to verify email. Please try again.',
    emailAlreadyInUse: 'Email already in use',
    enterValidEmail: 'Please enter a valid email address',
    failedToUpdateEmail: 'Failed to update email. Please try again.',
    passwordResetInitiated: 'A password reset link has been sent to your email address.',
    unableToLoadUser: 'Unable to load user information. Please try again.',
    retry: 'Retry',
    user: 'User',
    loadingUserInfo: 'Loading user information...',
    resetUserDataTitle: "Reset User Data",
    confirmResetUserData: "Are you sure you want to reset all your profile data? This will clear all your profile information and chat history, but keep your account credentials.",
    reset: "Reset",
    deleteAccountTitle: "Delete Account"
  },
  userProfile: {
    title: 'User Profile',
    privacyInfo: "By providing more information, you'll get more accurate and meaningful responses from the chatbot. Please review our",
    privacyPolicyLink: 'Privacy Policy',
    tabComingSoon: 'This tab is under development and will be available soon.',
    saveSuccess: 'Profile saved successfully',
    loadError: 'Error loading profile data',
    saveError: 'Error saving profile',
    confirmSaveTitle: "Save Profile",
    confirmSave: "Are you sure you want to save these changes?",
    confirmCancel: 'You have unsaved changes. Are you sure you want to cancel?',
    confirmLeave: 'Are you sure you want to leave? Any unsaved changes will be lost.',
    confirmDiscardChanges: 'Discard unsaved changes?',
    uploadPhoto: 'Upload Photo',
    uploadFile: 'Upload File',
    photoRequirements: 'Photo must be clear, recent, and show your full face',
    biometricRequirements: 'Only official biometric data files are accepted',
    documentUpload: 'Document Upload',
    validationTitle: 'Please correct the following errors:',
    profileIcon: 'Profile Icon',
    change: 'Change',
    chooseProfileIcon: 'Choose a Profile Icon',
    presetIcons: 'Preset Icons',
    upload: 'Upload',
    initials: 'Initials',
    clickToUpload: 'Click to upload',
    useThisImage: 'Use This Image',
    useInitials: 'Use Initials',
    tabs: {
      tab1: 'Personal Identification Data',
      tab2: 'Civil Registration & Documentation',
      tab3: 'Address & Residency Information',
      tab4: 'Identity & Travel Documents',
      tab5: 'Health & Medical Records',
      tab6: 'Employment & Economic Data',
      tab7: 'Education & Academic Records',
      tab8: 'Financial & Tax Data',
      tab9: 'Social Security & Welfare',
      tab10: 'Criminal & Legal Records',
      tab11: 'Transportation & Mobility',
      tab12: 'Civic & Political Participation'
    },
    actions: {
      cancel: 'Cancel',
      save: 'Save Profile',
      previous: 'Previous',
      next: 'Next',
      saving: 'Saving...'
    },
    fields: {
      fullName: 'Full name (including aliases)',
      dob: 'Date of birth',
      gender: 'Gender',
      nationality: 'Nationality',
      maritalStatus: 'Marital status',
      photograph: 'Photograph',
      biometric: 'Fingerprints / Biometric data',
      birthCert: 'Birth certificate',
      deathCert: 'Death certificate',
      marriageDivorce: 'Marriage / Divorce records',
      adoption: 'Adoption records',
      citizenship: 'Citizenship / Naturalization documents',
      immigration: 'Immigration & visa history',
      currentAddress: 'Current residential address',
      previousAddresses: 'Previous addresses',
      postalCode: 'Postal Code',
      country: 'Country',
      residencyStatus: 'Residency Status',
      homeOrRental: 'Homeownership or rental details',
      utilityBills: 'Utility bills linked to the address',
      landRecords: 'Land and property ownership records',
      idCard: 'National ID card number',
      passport: 'Passport details',
      driversLicense: "Driver's license",
      voterId: 'Voter ID',
      ssn: 'Social Security / National Insurance Number',
      militaryRecords: 'Military service records',
      medicalHistory: 'Medical history and health conditions',
      vaccinations: 'Vaccination records',
      insuranceDetails: 'Health insurance details',
      disability: 'Disability status',
      bloodType: 'Blood Type',
      organDonor: 'Organ donor status',
      prescriptions: 'Prescriptions and treatments received',
      mentalHealth: 'Mental health history',
      eHistory: 'Employment history',
      currentEmployer: 'Current employer details',
      workPermits: 'Work permits and labor contracts',
      certifications: 'Professional certifications and licenses',
      unemployment: 'Unemployment status and benefits received',
      tin: 'Taxpayer identification number (TIN)',
      businessAffiliations: 'Business ownership and company affiliations',
      schools: 'School and university attended',
      education: 'Education',
      degrees: 'Diplomas, degrees, and certifications',
      performance: 'Academic performance and test scores',
      academicRecords: "Academic Records",
      scholarships: 'Scholarships and financial aid received',
      incomeTax: 'Income tax records',
      bankAccounts: 'Banking and financial accounts',
      propertyTax: 'Property tax payments',
      businessTax: 'Business tax filings',
      pensionContrib: 'Pension contributions and withdrawals',
      loanAid: 'Loan and government aid records',
      pensionStatus: 'Pension status and contributions',
      childcare: 'Childcare support',
      foodAssistance: 'Food assistance / welfare programs',
      housingAssistance: 'Housing assistance',
      policeRecords: 'Police records (criminal history, arrests, charges)',
      courtCases: 'Court case history',
      finesPenalties: 'Fines and penalties',
      paroleProbation: 'Parole or probation status',
      citizenshipRevocation: 'Citizenship revocation (if applicable)',
      vehicleReg: 'Vehicle registration details',
      trafficViolations: 'Traffic violations and fines',
      licenseHistory: 'Driving license history and endorsements',
      publicTransportCard: 'Public transport card usage',
      voterRegistration: 'Voter registration details',
      electionHistory: 'Election participation history',
      partyMembership: 'Political party membership',
      militaryStatus: 'Military service or conscription status',
      publicServiceRoles: 'Public service roles'
    },
    placeholders: {
      fullName: 'Enter your full legal name',
      nationality: 'Enter your nationality',
      searchCountries: 'Search countries...',
      selectCountry: 'Select a country',
      searchDisciplines: "Search disciplines...",
      selectDiscipline: "Select a discipline",
      searchDegrees: "Search degrees...",
      selectDegree: "Select a degree"
    },
    validation: {
      nameRequired: 'Full name is required',
      dobRequired: 'Date of birth is required',
      dobFuture: 'Date of birth cannot be in the future',
      requiredField: '{field} is required',
      invalidFormat: 'Invalid format for {field}',
      futureDate: 'Date cannot be in the future',
      invalidSelection: 'Please make a valid selection',
      passwordLength: 'Password must be at least 8 characters',
      matchError: 'Fields do not match'
    },
    errors: {
      savingFailed: 'Failed to save profile',
      loadingFailed: 'Failed to load profile data',
      invalidForm: 'Please fill all required fields',
      invalidFileType: 'Invalid file type',
      fileTooLarge: 'File is too large',
      countryLoadError: 'Error loading countries',
      countryUpdateError: 'Error updating country'
    },
    notifications: {
      saveSuccess: 'Profile saved successfully',
      saveFailed: 'Failed to save profile',
      loadSuccess: 'Profile loaded successfully',
      loadFailed: 'Failed to load profile',
      fieldRequired: 'This field is required',
      uploadSuccess: 'File uploaded successfully',
      uploadFailed: 'Failed to upload file',
      formChanged: 'You have unsaved changes',
      sessionExpired: 'Your session has expired, please log in again',
      profileUpdated: 'Your profile has been updated',
      profileIncomplete: 'Your profile is incomplete'
    },
    instructions: {
      fullNameHelp: 'Enter your full legal name as it appears on your official documents',
      dobHelp: 'Enter your date of birth in MM/DD/YYYY format',
      uploadPhotoHelp: 'Upload a recent photo. File must be JPG, PNG, or GIF and less than 2MB',
      passwordHelp: 'Password must be at least 8 characters with one uppercase letter, one number, and one special character',
      documentHelp: 'Accepted formats: PDF, JPG, PNG (max 5MB)',
      requiredFields: 'Fields marked with * are required',
      selectFromList: 'Please select an option from the list',
      nextTab: 'Continue to next section',
      previousTab: 'Return to previous section',
      saveInstructions: 'Click Save to store your information',
      cancelInstructions: 'Click Cancel to discard changes'
    },
    completionStatus: {
      notStarted: 'Not Started',
      inProgress: 'In Progress',
      complete: 'Complete',
      percentComplete: '{percent}% complete',
      tabsCompleted: '{completed} of {total} sections completed',
      tabComplete: 'Tab completed!'
    },
    gender: {
      male: 'Male',
      female: 'Female',
      other: 'Other',
      preferNot: 'Prefer not to say'
    },
    maritalStatus: {
      single: 'Single',
      married: 'Married',
      divorced: 'Divorced',
      widowed: 'Widowed',
      other: 'Other'
    },
    residencyStatuses: {
      citizen: 'Citizen',
      permanentResident: 'Permanent Resident',
      temporaryResident: 'Temporary Resident',
      other: 'Other'
    },
    employmentStatuses: {
      employed: 'Employed',
      selfEmployed: 'Self-Employed',
      unemployed: 'Unemployed',
      student: 'Student',
      retired: 'Retired',
      homemaker: 'Homemaker',
      other: 'Other'
    },
    educationLevels: {
      primary: 'Primary Education',
      secondary: 'Secondary Education',
      highSchool: 'High School',
      vocational: 'Vocational Training',
      associate: 'Associate Degree',
      bachelor: 'Bachelor\'s Degree',
      master: 'Master\'s Degree',
      doctoral: 'Doctoral Degree',
      professional: 'Professional Degree',
      other: 'Other'
    },
    proficiencyLevels: {
      native: 'Native',
      fluent: 'Fluent',
      advanced: 'Advanced',
      intermediate: 'Intermediate',
      basic: 'Basic'
    },
    bloodTypes: {
      aPositive: 'A+',
      aNegative: 'A-',
      bPositive: 'B+',
      bNegative: 'B-',
      abPositive: 'AB+',
      abNegative: 'AB-',
      oPositive: 'O+',
      oNegative: 'O-',
      unknown: 'Unknown'
    },
    languages: {
      english: 'English',
      french: 'French',
      swahili: 'Swahili',
      arabic: 'Arabic',
      spanish: 'Spanish',
      portuguese: 'Portuguese',
      chinese: 'Chinese',
      japanese: 'Japanese',
      german: 'German',
      russian: 'Russian',
      hindi: 'Hindi',
      urdu: 'Urdu',
      other: 'Other'
    },
    yesNo: {
      yes: 'Yes',
      no: 'No'
    },
    select: 'Please select',
    existingFile: 'Existing file',
    noMatchingCountries: 'No matching countries found',
    noMatchingDisciplines: "No matching disciplines found",
    noMatchingDegrees: "No matching degrees found",
    educationOptions: [
      "Accounting", "Aerospace Engineering", "Agricultural Science", "Anthropology", "Architecture",
      "Art History", "Artificial Intelligence", "Astronomy", "Astrophysics", "Biochemistry",
      "Biomedical Engineering", "Biotechnology", "Business Administration", "Chemical Engineering",
      "Chemistry", "Civil Engineering", "Communications", "Computer Engineering", "Computer Science",
      "Construction Management", "Criminal Justice", "Cybersecurity", "Data Science", "Dentistry",
      "Economics", "Education", "Electrical Engineering", "Elementary Education", "English Literature",
      "Environmental Engineering", "Environmental Science", "Fashion Design", "Film Studies",
      "Finance", "Fine Arts", "Food Science", "Forensic Science", "Game Design", "Geography",
      "Geology", "Graphic Design", "Health Administration", "History", "Hospitality Management",
      "Human Resources", "Industrial Design", "Industrial Engineering", "Information Systems",
      "Information Technology", "Interior Design", "International Business", "International Relations",
      "Journalism", "Law", "Library Science", "Linguistics", "Management", "Marketing",
      "Materials Science", "Mathematics", "Mechanical Engineering", "Media Studies", "Medicine",
      "Meteorology", "Microbiology", "Music", "Nanotechnology", "Nursing", "Nutrition",
      "Occupational Therapy", "Oceanography", "Petroleum Engineering", "Pharmacy", "Philosophy",
      "Photography", "Physical Education", "Physical Therapy", "Physics", "Political Science",
      "Psychology", "Public Administration", "Public Health", "Public Relations", "Robotics",
      "Secondary Education", "Social Work", "Sociology", "Software Engineering", "Special Education",
      "Sports Management", "Statistics", "Systems Engineering", "Theatre Arts", "Tourism",
      "Urban Planning", "Veterinary Medicine", "Web Development", "Wildlife Biology", "Zoology"
    ],
    degreeOptions: [
      "Associate Degree", "Bachelor of Arts (BA)", "Bachelor of Science (BS)", "Bachelor of Engineering (BEng)",
      "Bachelor of Business Administration (BBA)", "Bachelor of Fine Arts (BFA)", "Bachelor of Education (BEd)",
      "Bachelor of Medicine (MBBS)", "Bachelor of Laws (LLB)", "Master of Arts (MA)", "Master of Science (MS)",
      "Master of Business Administration (MBA)", "Master of Engineering (MEng)", "Master of Fine Arts (MFA)",
      "Master of Education (MEd)", "Master of Laws (LLM)", "Master of Public Health (MPH)",
      "Doctor of Philosophy (PhD)", "Doctor of Medicine (MD)", "Doctor of Education (EdD)",
      "Doctor of Business Administration (DBA)", "Doctor of Jurisprudence (JD)", "Professional Diploma",
      "Technical Diploma", "Vocational Certificate", "Graduate Certificate", "Post-Graduate Diploma", "Post-Doctoral"
    ],
    aria: {
      tabList: 'Profile form sections',
      nextButton: 'Go to next section',
      prevButton: 'Go to previous section',
      closeButton: 'Close profile form',
      saveButton: 'Save profile data',
      requiredField: 'Required field',
      dropdownSelect: 'Select an option'
    }
  },
  chatbot: {
    placeholder: 'Type your query here...',
    sendButton: 'Send',
    fileReceived: 'File received successfully.',
    fileUploadError: 'Error uploading file.',
    processingError: 'Error processing your request.',
    welcomeMessage: 'Welcome! How can I assist you with Kenya government services today?',
    attachFile: 'Attach File',
    fileTooLarge: 'File is too large. Maximum size is {maxSize}.',
    saveChat: 'Save Chat',
    chatSaved: 'Chat Saved',
    chatTitle: 'Chat Title',
    chatTitlePlaceholder: 'Enter a title for this chat',
    selectFolder: 'Select Folder',
    newChat: 'New Chat',
    clearContext: 'Clear context and start a new conversation',
    unsavedChanges: 'You have unsaved changes. Are you sure you want to start a new chat?',
    whatCanIHelp: "How can I help you today?",
    justChat: "Just Chat",
    queryContext: "Query Context",
    contextAdded: 'Context added to your query',
    contextRemoved: 'Context removed from your query',
    sessionUpdated: 'Session updated',
    newChatStarted: 'Started a new conversation',
    loadError: 'Unable to load chat history',
    responsePrefix: "I received your message",
    withContext: "with context",
    conversationLoaded: "Conversation loaded successfully!",
    saveConfirmTitle: "Save Existing Conversation",
    saveConfirmMessage: "Save existing conversation?",
    loadConfirmTitle: "Load Existing Conversation",
    loadConfirmMessage: "You have unsaved changes. Do you want to discard them and load the selected conversation, or save the current conversation first?",
    loadAndDiscard: "Load and Discard",
    saveAndLoad: "Save and Load",
    saveAndStartNew: "Save and Start New",
    discardAndStartNew: "Discard and Start New",
    newChatTitle: "Start New Chat",
    exportChat: 'Export Chat',
    exportFilename: 'File Name',
    exportFilenamePlaceholder: 'Enter file name',
    exportButton: 'Export',
    exportSuccess: 'Chat exported successfully',
    exportError: 'Failed to export chat. Please try again.'
  },
  quickhelp: {
    // Labels (Short for UI)
    applyForID: "Apply for ID",
    payTaxes: "Pay Taxes",
    startBusiness: "Start Business",
    findHealthcare: "Healthcare",
    educationServices: "Education",
    transportLicenses: "Transport",
    housingPrograms: "Housing",
    findJobs: "Find Jobs",
    justChat: "Just Chat",

    // User Prompts (Visible Text - First Person - what user sees in chat)
    justChatUserPrompt: "I'd like to chat about government services",
    applyForIDUserPrompt: "I need information on how to apply for a national ID card",
    payTaxesUserPrompt: "What's the process for paying my taxes online?",
    startBusinessUserPrompt: "Guide me through the steps to register a new business",
    findHealthcareUserPrompt: "Where can I find information about public healthcare services?",
    educationServicesUserPrompt: "What education services are available for my children?",
    transportLicensesUserPrompt: "How do I renew my driving license?",
    housingProgramsUserPrompt: "Tell me about affordable housing programs in Kenya",
    findJobsUserPrompt: "What government job opportunities are currently available?",

    // System Prompts (Hidden from User - detailed prompts sent to LLM)
    applyForIDPrompt: "Act as a helpful Kenyan civil registration expert. Explain the steps for obtaining a National ID (Maisha Namba) or replacing a lost one. IMPORTANT: Provide a clear list of required documents (e.g., Birth Certificate, copies of parents' IDs) and advise the user to visit their nearest Huduma Centre or Registrar of Persons office. RULE: Always refer to the application as 'Genie AI'.",

    payTaxesPrompt: "Act as a KRA (Kenya Revenue Authority) guide. Explain the process of filing returns, applying for a KRA PIN, or resetting a password on the iTax portal. IMPORTANT: Remind the user of the June 30th deadline for annual returns and guide them on how to file Nil returns if they had no income. RULE: Always refer to the application as 'Genie AI'.",

    startBusinessPrompt: "Act as a business consultant for eCitizen services. Guide the user through business name reservation and company registration in Kenya. IMPORTANT: Explain the current costs for name search and registration, and direct the user to the official eCitizen portal to complete the application. RULE: Always refer to the application as 'Genie AI'.",

    findHealthcarePrompt: "Act as a health services navigator. Provide information on the transition from NHIF to SHIF (Social Health Insurance Fund) and how to register. IMPORTANT: Share the official USSD codes (like *263#) or website links for registration and explain the benefits of the public health cover. RULE: Always refer to the application as 'Genie AI'.",

    educationServicesPrompt: "Act as an education counselor. Discuss the CBC curriculum, NEMIS registration, or university placement via KUCCPS. IMPORTANT: Explain how parents can check national exam results via SMS or the KNEC portal when released. RULE: Always refer to the application as 'Genie AI'.",

    transportLicensesPrompt: "Act as an NTSA service guide. Explain the process for driving license renewal, vehicle inspection, or TIMS account management. IMPORTANT: Guide the user on how to log in to the eCitizen NTSA portal to apply for their Smart DL or book a vehicle inspection. RULE: Always refer to the application as 'Genie AI'.",

    housingProgramsPrompt: "Act as a housing program advisor. Explain the Affordable Housing Program (Boma Yangu) registration and voluntary contribution process. IMPORTANT: Guide the user to the Boma Yangu portal to view projects and explain the eligibility criteria for allocation. RULE: Always refer to the application as 'Genie AI'.",

    findJobsPrompt: "Act as a career coach for the public service. Guide the user on creating a profile and applying for vacancies via the Public Service Commission (PSC) portal. IMPORTANT: Advise the user to keep their academic certificates ready and to regularly check the PSC website or local dailies for MyGov advertisements. RULE: Always refer to the application as 'Genie AI'.",

    justChatPrompt: "Act as a friendly local companion. Be polite, helpful, and knowledgeable about Kenyan culture and daily life. IMPORTANT: Remind the user that while you can chat about anything, your main strength is helping them navigate Kenyan government services like **IDs**, **Taxes**, and **Business Registration**. RULE: Always refer to the application as 'Genie AI'."
  },
  common: {
    cancel: 'Cancel',
    create: 'Create',
    save: 'Save',
    move: 'Move',
    delete: 'Delete',
    // --- NEW KEYS ADDED ---
    ok: 'OK',
    ingest: 'Ingest',
    retract: 'Retract',
    loading: 'Loading...',
    refresh: 'Refresh'
  },
  feedback: {
    title: 'Feedback',
    button: 'Feedback',
    positive: 'Positive feedback',
    negative: 'Negative feedback',
    promptText: 'Was this response helpful?',
    placeholder: 'Additional comments...',
    submit: 'Submit Feedback',
    close: 'Cancel',
    thankYouMessage: 'Thank you for your feedback!',
    submitting: 'Submitting...',
    error: 'Something went wrong. Please try again.',
    success: 'Thank you for your feedback!',
  },
  responseRating: {
    title: 'Help Us Improve',
    note: 'Your feedback will be used to better tune the chatbot and improve responses over time.',
    chatbotResponse: 'Chatbot Response:',
    ratingLabels: {
      1: 'Useless',
      2: 'Slightly Helpful',
      3: 'Moderately Helpful',
      4: 'Very Helpful',
      5: 'Life Changing'
    },
    additionalComments: 'Additional comments...',
    submit: 'Submit',
    cancel: 'Cancel'
  },
  upload: {
    alt: 'Upload'
  },
  details: {
    loading: 'Loading File Details...',
    title: 'File Details',
    close: 'Close',
    fileName: 'File Name',
    author: 'Author',
    labels: 'Labels',
    selectAll: 'Select All',
    loadingLabels: 'Loading labels...',
    status: 'Status',
    fileId: 'File ID',
    fileType: 'File Type',
    viewFile: 'View File',
    visitLink: 'Visit External Link',
    openFile: 'Open file in new tab',
    fileSize: 'File Size',
    uploadDate: 'Upload Date',
    hash: 'SHA256 Hash',
    // --- NEW: TABS ---
    tabs: {
      details: "Details",
      ingestionLog: "Ingestion Log"
    },
    // --- NEW: LOG TAB ---
    log: {
      killActions: "Kill Actions:",
      killDocument: "Kill This Document",
      killProcess: "Kill Ingestion Process",
      timestamp: "Timestamp",
      level: "Level",
      stage: "Stage",
      message: "Message",
      loadingLogs: "Loading logs...",
      noLogs: "No logs found."
    },
    buttons: {
      saveMetadata: 'Save Metadata',
      retract: 'Retract',
      ingest: 'Ingest'
    },
    notifications: {
      loadError: 'Failed to load file details.',
      validationError: 'File Name and Author are required.',
      saveSuccess: 'Metadata updated successfully.',
      saveError: 'Failed to save metadata.',
      tokenError: 'Authentication token not found in user data.',
      viewError: 'Could not load file for viewing.',
      ingestSuccess: 'File has been successfully queued for ingestion.',
      ingestError: 'Failed to start ingestion process.',
      retractSuccess: 'File has been retracted.',
      retractError: 'Failed to retract file.',
      deleteSuccess: 'File deleted successfully.',
      deleteError: 'Failed to delete file.',
      // --- NEW NOTIFICATIONS ---
      ingestLabelRequired: "Please select at least one label before ingesting.",
      ingestSaving: "Saving metadata before ingestion...",
      ingestSaveFailed: "Failed to save metadata. Ingestion cancelled.",
      logError: "Failed to fetch ingestion logs.",
      killDocSent: "Kill request for this document has been sent.",
      killProcSent: "Kill request for the ingestion process has been sent."
    },
    confirm: {
      ingest: 'Are you sure you want to ingest this file? This will start the data processing pipeline.',
      retract: 'Are you sure you want to retract this file?',
      delete: 'Are you sure you want to permanently delete this file? This action cannot be undone.',
      // --- NEW CONFIRMATIONS ---
      ingestTitle: "Confirm Ingestion",
      retractTitle: "Confirm Retraction",
      deleteTitle: "Confirm Deletion",
      killDocTitle: "Kill Document Ingestion",
      killDoc: "Are you sure you want to kill the ingestion task for THIS document? The process will attempt a graceful rollback.",
      killProcTitle: "Kill ENTIRE Ingestion Process",
      killProc: "WARNING: This will kill the entire backend ingestion service, affecting ALL files currently processing. Are you absolutely sure?"
    }
  },
  uploadDialog: {
    title: 'Upload Files',
    dropzone: 'Drag & drop files here, or click to select',
    allowedTypesLabel: 'Allowed types:',
    buttonUpload: 'Upload {count} File(s)',
    remove: 'Remove',
    uploading: 'Uploading...',
    notifications: {
      dropError: 'Only files can be dropped. Please check you are dragging a valid file from your computer.',
      typeNotAllowed: 'File type "{extension}" is not allowed.',
      shortcutUnsupported: 'Shortcut files (.url) are not supported. Please drag the actual file.',
      duplicate: 'File "{fileName}" has already been added.',
      uploadSuccess: 'Successfully uploaded {fileName}',
      uploadFailed: 'Failed to upload {fileName}.'
    }
  }
}